<script setup>
import axios from "axios"
import { onMounted, ref } from "vue"
import { PrimaryButton } from "@codinglabsau/ui"
import { PencilSquareIcon } from "@heroicons/vue/24/solid"
import Modal from "@/Components/Inputs/BlockEditor/Extension/Components/Modal.vue"
import SearchSelectInput from "@/Components/Inputs/CategorySearchSelectFilter.vue"
import ToolbarButton from "@/Components/Inputs/BlockEditor/Extension/Components/ToolbarButton.vue"

const props = defineProps({
  categoryName: {
    required: true,
  },
  limit: {
    required: true,
  },
})

let showDialogue = ref(false)

const emits = defineEmits(['update:category', 'update:limit', 'auctions'])

const categoryName = defineModel('categoryName')
const limit = defineModel('limit')

const selectCategory = (category) => {
  categoryName.value = category.name
  fetchAuctions(category.name)
}

const fetchAuctions = (search) => {
  axios.get(route('hq.auctions.algolia.search'), {
    params: {
      search: search,
    }
  }).then((res) => {
    emits('auctions', res.data)
  })
}

onMounted(() => {
  if (props.categoryName) {
    fetchAuctions(props.categoryName)
  }
})
</script>

<template>
  <ToolbarButton :label="__('Edit Algolia Category')" :icon="PencilSquareIcon" v-model="showDialogue"/>
  <Modal v-model="showDialogue">
    <template #title>
      {{ __('Edit Algolia Category') }}
    </template>

    <template #description>
      {{ __('Add the category and limit on the number of auctions per component.') }}
    </template>

    <div class="space-y-2">
      <div>
        <label for="category">{{ __('Category') }}</label>
        <SearchSelectInput
          id="category"
          :url="route('hq.categories.search')"
          :placeholder="categoryName"
          @filter="selectCategory"
        />
      </div>

      <div>
        <label for="limit">{{ __('Limit') }}</label>
        <input
          id="limit"
          type="number"
          v-model="limit"
          :min="0"
          :max="32"
        />
      </div>
    </div>

    <p class="text-gray-400 text-sm">
      {{ __('*Note: More then one category component will not work properly when outside of the page builder.')}}
    </p>

    <PrimaryButton class="mt-2" type="button" @click.prevent="showDialogue = false">{{ __('Done') }}</PrimaryButton>
  </Modal>
</template>
